import { shallowRef } from 'vue'
import type { AppState } from '../types/domain'
export const sharedLinksView = shallowRef<{visible:boolean;data:AppState|null}>({visible:false,data:null})
let refresh = async () => {}
export function connectSharedLinks(handler:()=>Promise<void>) { refresh=handler }
export function refreshSharedLinks(){return refresh()}
